import { render, staticRenderFns } from "./addcommercial_qdxx.vue?vue&type=template&id=5e7cc258&scoped=true&"
import script from "./addcommercial_qdxx.vue?vue&type=script&lang=js&"
export * from "./addcommercial_qdxx.vue?vue&type=script&lang=js&"
import style0 from "./addcommercial_qdxx.vue?vue&type=style&index=0&id=5e7cc258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7cc258",
  null
  
)

export default component.exports